export default "__VITE_ASSET__BJVrGDIV__"